// extracted by mini-css-extract-plugin
export var clickThrough = "_xh-2";
export var fallback = "_xh-5";
export var frame = "_xh-3";
export var frameCell = "_xh-1";
export var overlay = "_xh-4";
export var wrapper = "_xh-0";